var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0798 12.556H37.6883V9.38234C37.6883 8.06622 36.566 7 35.1806 7C33.7953 7 32.673 8.06622 32.673 9.38234V12.556H21.3095V9.38234C21.3095 8.06622 20.1872 7 18.8018 7C17.4165 7 16.2942 8.06622 16.2942 9.38234V12.556H8.92021C7.86804 12.556 7 13.3807 7 14.3803V45.1758C7 46.1753 7.86804 47 8.92021 47H45.0798C46.132 47 47 46.1753 47 45.1758V14.3803C47 13.3807 46.132 12.556 45.0798 12.556ZM42.4844 38.2453C42.4844 38.7451 42.1688 39.4365 41.7918 39.7863L38.9246 42.3769C38.5388 42.7268 37.7935 43.01 37.2674 43.01H12.4713C11.9452 43.01 11.5156 42.6018 11.5156 42.102V23.7347C11.5156 23.2349 11.9452 22.8267 12.4713 22.8267H41.5199C42.046 22.8267 42.4757 23.2349 42.4757 23.7347V38.2536L42.4844 38.2453Z",
    fill: "#008577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25H16V31H22V25Z",
    fill: "#008577"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25H24V31H30V25Z",
    fill: "#008577"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25H32V31H38V25Z",
    fill: "#008577"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34H16V40H22V34Z",
    fill: "#008577"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34H24V40H30V34Z",
    fill: "#008577"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 34H32V40H38V34Z",
    fill: "#008577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Icon);
export default __webpack_public_path__ + "static/media/step2-icon.ceb770819593d1dbcb0d7380ce2b2366.svg";
export { ForwardRef as ReactComponent };